<style lang="less">
    .sketch-dialog {
        width: 504px;
    }
</style>
<i18n>
{
  "zh": {
    "sketchTitle": "选择颜色"
  },
  "en": {
    "sketchTitle": "Select Color"
  },
  "jp": {
    "sketchTitle": "色を選択"
  },
  "de": {
    "sketchTitle": "Farbe auswählen"
  },
  "fr": {
    "sketchTitle": "Sélectionner la couleur"
  },
  "es": {
    "sketchTitle": "Selecciona el color"
  },
  "pt": {
    "sketchTitle": "Selecionar Cor"
  },
  "it": {
    "sketchTitle": "Seleziona Colore"
  },
  "tw": {
    "sketchTitle": "選擇顏色"
  }
}
</i18n>
<template>
    <Dialog
        class="sketch-dialog"
        :mask="true"
        :title="$t('sketchTitle')"
        :showFooter="true"
        :extra="true"
        @ok="ok"
        @close="cancel"
        @click.native.stop
    >
        <Sketch ref="sketch" :value="currentColor" />
    </Dialog>
</template>

<script lang="ts">
    import Dialog from "../../Modals/Dialog.vue";
    import Sketch from "./Sketch.vue";
    import { Component, Prop, Vue } from "vue-property-decorator";

    // @Component 修饰符注明了此类为一个 Vue 组件
    @Component({
        components: {
            Dialog,
            Sketch,
        },
    })
    export default class SketchDialog extends Vue {
        // 初始数据可以直接声明为实例的属性
        get currentColor() {
            return this.$store.state.ui.currentColor;
        }
        ok() {
            let ts = this as any;
            let sketchFuncName = "sketchOK";
            if (this.$store.state.dialog.sketchType) {
                sketchFuncName += this.$store.state.dialog.sketchType;
            }
            ts.$bus.$emit(sketchFuncName, (<any>this).$refs.sketch.colors.hex);
            this.$store.commit("setDialogState", {
                type: "showSketch",
                data: false,
            });
            this.$store.commit("setDialogState", {
                type: "sketchType",
                data: null,
            });
            this.$store.commit("setStatus", {
                type: "showPalette",
                data: true,
            });
            window["_view"].hoverLeava();
            this.$store.commit("toPalette", { type: null });
        }
        cancel(e) {
            this.$store.commit("setDialogState", {
                type: "showSketch",
                data: false,
            });
            this.$store.commit("setDialogState", {
                type: "sketchType",
                data: null,
            });
            this.$store.commit("setStatus", {
                type: "showPalette",
                data: true,
            });
            this.$store.commit("toPalette", { type: null });
            window["_view"].hoverLeava();
        }

        // computed
        get computeMsg() {
            return "computed";
        }

        //生命周期
        mounted() {}

        created() {}
    }
</script>
